export default {
  passport_ru: 'Russian passport',
  passport_ru__hint: 'Photos of all used pages',
  snils: 'Pension insurance certificate/SNILS',
  tax_identification_number: 'TIN (Taxpayer Identification Number)',
  tax_identification_number_ua: '@:field.tax_identification_number',
  tax_identification_number_ua__hint: `
  <a href="https://drive.google.com/drive/folders/1PDtSh3860ckUU5uh6f8UQRnHPrCP1dN2" target="_blank">Example</a>`,
  employment_history: 'Employment record book (every page that has been filled in)',
  employment_history__hint: `If an employee enters work for the first time or the book is lost, it
    is necessary to indicate this and the accountant will instruct on further steps after leaving`,
  employment_history_ua:
    'Employment record book: the first and last pages, with a record of dismissal from the last job.',
  employment_history_ua__hint: `If an employee enters work for the first time or the book is lost,
    it is necessary to indicate this and the accountant will instruct on further steps after leaving`,
  education_document: `Documents about specialized education (specialty, qualifications) and diploma
    supplement for higher education`,
  education_document_by: 'Document about education',
  military_registration_document: 'Military registration documents',
  military_registration_document__hint: `For persons liable for military service and persons subject
    to conscription (photo of all pages where there is an entry)`,
  disability_certificate: 'Certificate/Verification of disability',
  disability_certificate__hint: 'Mandatory if you have a disability',
  child_tax_identification_number: `A copy of a certificate from the state tax authority
  on the assignment of an identification number for a child (VHI for a child is issued only
  if the child's identification number is provided)`,
  child_birth_certificate: `Child's birth certificate`,
  child_birth_certificate__hint: 'If you have children under 18 years old',
  child_birth_certificate_ua: `Child's birth certificate`,
  child_birth_certificate_ua__hint: 'If you have children under 18 years old',
  passport_by: 'Belarusian passport or other form of identification',
  passport_by__hint: 'Photos of all used pages',
  passport_ua: `Passport or ID card with an extract from the EGDR showing the address at which you
    are registered`,
  passport_ua__hint: `
  <a href="https://drive.google.com/drive/folders/1SEaoQZOhgLAxkMMb-lfxSbRaII_xp8oU" target="_blank">Example</a>`,
  '182-n_document':
    'Certificate 182-N from all employers for the current year and the previous two years',
  '182-n_document__hint': 'Add photo/scan, send original after exit',
  '2ndfl_document': 'Form 2NDFL for the current year',
  '2ndfl_document__hint': 'If you have children under 18 years old',
  bank_details: 'Bank details for the transfer of wages',
  bank_details__hint: 'Mandatory - personal account',
  std_documents: 'Form STD-PFR, STD-R',
  std_documents__hint: `Photo of all completed pages of your employment record book, if your
    previous employer opted for an electronic version and there is a corresponding note about this`,
  social_insurance_certificate_ua: 'Certificate of Compulsory State Social Insurance (if any)',
  cv_document: 'CV',
  benefit_statement: 'Benefit Application',
  benefit_statement__hint: 'Application for a tax social benefit',
  medical_examination_certificate: 'Medical examination certificate',
  medical_examination_certificate__hint: `For a referral for a medical examination, indicate your
    full name and date of birth in the response letter. Our office manager will contact you with
    all the details`,
  medical_examination_certificate_ua: 'Medical examination certificate',
  medical_examination_certificate_ua__hint: `The referral will be sent by an accountant on your
    first working day. Relevant for office employees once quarantine ends`,
  social_insurance_certificate_by: 'Insurance certificate of state social insurance',
  social_insurance_certificate_by__hint: `If there is not and it was not obtained earlier, it is
    necessary to indicate this and the accountant will instruct on further steps after the exit`,
  bank_details_by: `Bank account details, in "Priorbank", because we have an agreement with this
    bank and the company pays the commission for the transfer of funds.`,
  bank_details_by_hint:
    'When opening a bank account, you must say that your legal entity has a payroll agreement with the bank.',
  full_name_en: 'Full name',
  full_name_en__hint: 'As shown in your passport',
  citizenship: 'Citizenship',
  passport_number: 'Passport or ID card',
  passport_number__hint: 'If you have an international passport, then its number',
  residence_address: 'Residence address',
  residence_address__hint: 'ZIP Code, Country, City, Street, Building and Apartment #',
  bank_details_en: 'Bank details',
  bank_details_en__hintAbove: `If your offer is in dollars, we need the details for your dollar
    account. If your offer is in euros, then your euro account. If you do not have a foreign
    currency account, you must open one before your start date. You can also request a bank
    statement — they usually provide this in PDF format.`,
  email_plr: 'Email',
  beneficiary_bank_name: `Beneficiary's bank name`,
  beneficiary_bank_swift: `Beneficiary's bank SWIFT/BIC`,
  beneficiary_bank_iban: 'Beneficiary account number',
  intermediary_bank_name: 'Correspondent bank name',
  intermediary_bank_swift: 'Correspondent bank SWIFT',
  intermediary_bank_iban: 'Correspondent bank account',
  photo3x4: 'Photo 3*4',
  photo3x4__hint:
    'Send the original to the accounting department after leaving the company after receiving the request',
  rehabilitation_plan: 'Individual rehabilitation plan',
  rehabilitation_plan__hint: `It is advisable to provide these documents in advance, since in
    the rehabilitation plan, conditions may be prescribed that we cannot provide and, accordingly,
    cannot be hired.`,
};
